import type { CategoryResponse } from "@models/category";

export const findCategory = (
    categories: CategoryResponse[],
    targetId: number,
): CategoryResponse | undefined => {
    for (const cat of categories) {
        if (cat.id === targetId) return cat;
        const found = findCategory(cat.children, targetId);
        if (found) return found;
    }
    return undefined;
};

export const buildCategoryChain = (
    categories: CategoryResponse[],
    targetId: number,
): CategoryResponse[] => {
    for (const cat of categories) {
        if (cat.id === targetId) return [cat];
        const childChain = buildCategoryChain(cat.children, targetId);
        if (childChain.length > 0) return [cat, ...childChain];
    }
    return [];
};
